import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonText, IonIcon,IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory, useLocation } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import Select from 'react-select';
import service from "../../Service/service"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline, create } from "ionicons/icons";


const ProjectClosure: React.FC = () => {
    const history = useHistory();
    const location: any = useLocation()
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            if (location.state) {
                console.log(location)
                setId(location.state.projectId)

            }

        }
    }, [token, history]);
    const [data, setData]: any = useState([]);
    const [showfield, setshowfield] = useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");
    const [loading,setloading]=useState(false)

    const [modalopen, setModalopen] = useState(false);

    const [id, setId] = useState("");

    const [showRemainingDesign, setShowRemainingDesign] = useState(false);
    const [clientView, setClientView] = useState([]);

    // const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [updatedBy] = useState(localStorage.getItem("SignupEmpId"));

    const [remarks, setRemarks] = useState('')
    const [bussinessUnitArr1, setBussinessUnitArr1]: any = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [projectManagerArr, setProjectManagerArr] = useState([]);
    const [showClosureHoldForm, setShowClosureHoldForm] = useState(false);

    const [isEdit, setIsEdit] = useState(true);
    const [projectStatus, setProjectStatus] = useState('');
    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));
    /*........Create.......... */

    const [bussinessUnit, setBussinessUnit] = useState("");
    const [departmentUnit, setDepartmentUnit] = useState("");
    const [projectManager, setProjectManager] = useState("")

    /*......... VIew & Update .......... */
    const [pname, setPname] = useState("");
    const [cname, setCname] = useState("");
    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [desc, setDeasc] = useState("");
    const [assignedResources, setAssignedResources] = useState([]);
    const [updateBussinessUnit, setUpdateBussinessUnit] = useState("");
    const [updateDepartmentUnit, setUpdateDepartmentUnit] = useState("");
    const [updateProjectManager, setUpdateProjectManager] = useState("")
    const [hideButtons, setHideButtons] = useState(false);


    /*............ Assign Project............... */
    const inputArr1 = [
        {
            employeeId: "",
            projectId: "",
            assignedBy: "",
            responsibilities: "",
            businessUnitId: ""
        }
    ];


    const [assign]: any = useState(localStorage.getItem("SignupEmpId"));

    /*.............. Activity Code ........... */

    const inputArr = [
        {
            activityCode: "",
            activityMeta: "",
            activityDescription: "",
            projectId: "",
            createdBy: "",
            parentActivityId: "",
        }
    ]

    /*.............. Get current date  ........... */

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to the month because it's 0-indexed
        const day = today.getDate().toString().padStart(2, '0');

        return `${day}-${month}-${year}`; // Adjust the format as needed
    }


    //-----------------Businessunit Autocomplete----------------// 

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const [statusList, setStatusList] = useState([]);
    const [projectStatusId, setProjectStatusId] = useState("");
    const [btnStatus, setBtnStatus] = useState([])

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };
    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }
    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholders = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Business Unit </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const optionss = bussinessUnitArr1.map((state: any) => ({
        value: state.id,
        label: state.businessUnitName,
    }));

    const handleBusinessChange = (selectedOption1: any) => {
        console.log(selectedOption1.value, "kn");
        setBussinessUnit(selectedOption1.value);
        setUpdateBussinessUnit(selectedOption1.value)
        ViewAllDepartmentunit(selectedOption1.value);
    };
    //.................Project Status........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Open</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options9 = statusList.map((state: any) => ({
        value: state.id,
        label: state.status,
    }));

    const hanldeStatusTypes = (selectedOption9: any) => {
        setProjectStatusId(selectedOption9.value)
    }
    //-------------------Departmentunit Autocomplete---------------//

    const [selectedOption2, setSelectedOption2] = useState(null);
    const [inputValue2, setInputValue2] = useState('');
    const [isFocused2, setIsFocused2] = useState(false);
    const [menuIsOpen2, setMenuIsOpen2] = useState(false);

    const handleStateChange2 = (selectedOption2: any) => {
        setSelectedOption2(selectedOption2);
    };

    const handleInputChange2 = (inputValue2: any) => {
        setInputValue2(inputValue2);
    };

    const handleMenuOpen2 = () => {
        setMenuIsOpen2(true);
    };

    const handleMenuClose2 = () => {
        setMenuIsOpen2(false);
    };

    const handleFocus2 = () => {
        setIsFocused2(true);
    };

    const handleBlur2 = () => {
        setIsFocused2(false);
    };

    const Placeholder2 = () => {
        if (inputValue2 === '' && !selectedOption2 && !isFocused2) {
            return <span style={{ color: "black" }}>Select Department Unit </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen2) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen2]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const optionsss = departmentUnitArr.map((state: any) => ({
        value: state.id,
        label: state.departmentName,
    }));

    const handleDepartmentChange = (selectedOption2: any) => {
        console.log(selectedOption2.value, "kn");
        setDepartmentUnit(selectedOption2.value);
        setUpdateDepartmentUnit(selectedOption2.value)
    };

    //-------------Project Manager Autocomplete-------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Project Manager </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = projectManagerArr.map((state: any) => ({
        value: state.id,
        label: state.name,
    }));
    const handleprojectUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setProjectManager(selectedOption.value);
        setUpdateProjectManager(selectedOption.value)
    };
    const resetRemarks = () => {
        setHideButtons(false);
        setRemarks('');
    };

    //----------------Getall Projects Datatable---------------// 

    const columns: any = [
        {
            name: "S.No",
            cell: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "83px",
        },
        {
            name: (<div>Business<br/>Unit</div>),
            // selector: (itm: any) => itm.businessUnit.businessUnitName,
            selector: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NA';
                }
            },

            sortable: true,
            sort: "businessUnitName",
            width: "120px"
        },
        {
            name: (<div>Department</div>),
            // selector: (itm: any) => itm.masterDepartment.departmentName,
            selector: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NA';
                }
            },
            sortable: true,
            sort: "departmentName",
            width: "150px"
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,
            width: "250px",
            
        },
        {
            name: (<div>Created<br/>Date</div>),
            selector: (itm: any) => itm.createdDate,
            sortable: true,
            sort: "createdDate",
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            },
            width: "105px"
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
            width: "190px"

        },
        {
            name: (<div>Resources<br/></div>),
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
            width: "105px"
        },
        {
            name: "Status",
            // selector: (itm: any) => itm.projectStatus.status,
            sortable: true,
            width: "95px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.projectStatus.status === "Open" ? (
                        <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                    ) : itm.projectStatus.status === "Hold" ? (
                        <p style={{ color: "orange", margin: '0' }}>Hold</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>Close</p>
                    )}
                </div>

            )
        },
        {
            name: "View",
            sortable: false,
            // width: "100px",
            cell: (itm: any) => (
                <div>
                    <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }}>View</IonText>
                </div>
            )

        },
    ];


    const customStyles = {
        headRow: {
            style: {
                
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
                
            },
        },
        cells: {
            style: {
                fontSize: "15px",
                // width:"100px"
            }
        }
    };
    //---------------Search filter---------------//

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //---------------Getall Api------------------//    

    useEffect(() => {
        var role = localStorage.getItem("UserRole")
        console.log(role, "kmk")
        if (role === "MANAGER" || role === "Manager") {
            setIsEdit(false)
        }
        else {
            setIsEdit(true)
        }
        AllClients();
        LoadProject();
        ViewProjectManagerList();
        ViewAllBusinessunitDropDown();
        GetStatusList();
    }, [])

    const LoadProject = () => {
        setloading(true);
        service.GetallProject(createdBy, projectStatusId)
            .then((response) => {
                console.log(response);
                if (response.data.status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
              
                setTimeout(() => {
                    setloading(false); 
                }, 500); 
            });
    };
    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    // Filter out the "Close" option from the response data
                    const filteredData = response.data.filter((item: any) => item.status !== 'Close');
                    setStatusList(filteredData);
                    setBtnStatus(response.data)
                } else {
                    setStatusList([]);
                    setBtnStatus([])
                }
            });
    };


    //    ------------------ Project closure----------------
    const AssignGeneralActivity = () => {
        service
            .ProjectClosure(id, projectStatusId, remarks, createdBy,token)
            .then((response) => {
                console.log(response);
                if (response.data.status === "200") {
                    swal("", response.data.message, "success").then(() => {
                        window.location.reload();
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                swal("", "An error occurred during the transfer.", "error");
            });
    };


    /*.............. close/hold  ........... */

    function handleClick(action: string) {
        setshowfield(true);
        let actionText = '';
        let swalText = '';
        let buttons;
    
        if (action === 'close') {
            actionText = 'Close';
            const filteredData: any = btnStatus.filter((item: any) => item.status === 'Close');
            console.log(filteredData, "kmkk");
            setProjectStatusId(filteredData[0].id);
            swalText = `Resources assignment to this project will be removed – Effort cannot be logged henceforth on this project`;
            buttons = {
                yes: {
                    text: 'Yes',
                    value: 'yes',
                    className: 'btn-yes',
                },
                no: {
                    text: 'No',
                    value: 'no',
                    className: 'btn-no'
                },
               
            };
        } else if (action === 'hold') {
            actionText = 'Hold';
            const filteredData: any = btnStatus.filter((item: any) => item.status === 'Hold');
            console.log(filteredData, "kmkk");
            setProjectStatusId(filteredData[0].id);
            swalText = `Resources assignment to this project will be removed – Effort cannot be logged henceforth on this project`;
            buttons = {
                yes: {
                    text: 'Yes',
                    value: 'yes',
                    className: 'btn-yes',
                },
                no: {
                    text: 'No',
                    value: 'no',
                    className: 'btn-no'
                },
               
            };
        } else if (action === 'Unhold') {
            actionText = 'Unhold';
            const filteredData: any = btnStatus.filter((item: any) => item.status === 'Open');
            console.log(filteredData, "kmkk");
            setProjectStatusId(filteredData[0].id);
            swalText = `Assign resources to the project – for you to log time against this project`;
            buttons = {
                ok: true,
            };
        }
    
        swal({
            title: `To ${actionText} Project`,
            className: "project",
            text: swalText,
            icon: 'info',
            buttons: buttons,
            closeOnClickOutside: false,
        }).then((value: string) => {
            if (value === 'no') {
                setshowfield(false)
                setHideButtons(false);
                setModalopen(false);
            } else if (value === 'yes') {
                setHideButtons(true);
            } else if (value === 'ok') {
                setHideButtons(true);
            } 
        });
    }
    // .then((value: string) => {
    //     if (value  === 'yes') {
    //         setHideButtons(true);
    //     } else if(value === 'no') {
    //         setModalopen(false);
    //         setHideButtons(false);
    //     }
    // });
    // --------------------hide button-----------------
    
    //  let buttons;

    // if (projectStatus === 'Hold') {
    //     buttons = (
    //         <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('Unhold')}>UnHold</button>
    //     );
    // } else if (projectStatus === 'Close') {
    //     buttons = null;
    // } else {
    //     buttons = (
    //         <>
    //             <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('close')}>Close</button>
    //             <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('hold')}>Hold</button>
    //         </>
    //     );
    // }

    let buttons = null;

    if (!hideButtons) {
        if (projectStatus === 'Hold') {
            buttons = (
                <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('Unhold')}>UnHold</button>
            );
        } else if (projectStatus === 'Close') {
        buttons=null;
        } else {
            buttons = (
                <>
                    <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('close')}>Close</button>
                    <button type="button" className="btn-primary submit-btn" onClick={() => handleClick('hold')}>Hold</button>
                </>
            );
        }
    }
    //--------------Clients Dropdown Api-----------------//

    const AllClients = () => {
        service.GetAllClientNameDropDown()
            .then((response) => {
                console.log("All Client")
                console.log(response);
                if (response.data.status === "200") {
                    setClientView(response.data.data)
                    setCname(cname)

                }
                else {
                    setClientView([])
                }
            })
    }

    //--------------------Businessunit Dropdown Api-----------------//

    const ViewAllBusinessunitDropDown = () => {
        service.GetDropDownBusinessUnitOnProject(createdBy)
            .then((response) => {
                console.log("Bussiness Unit", business)
                console.log(response);

                if (response.data.Status === "200") {
                    setBussinessUnitArr1(response.data.Data)

                }
                else {
                    setBussinessUnitArr1([])
                }
            })
    }

    //-----------------Departmentunit Dropdown Api-------------------//

    const ViewAllDepartmentunit = (id: any) => {
        setDepartmentUnit("");
        console.log(id, "lmlm")
        var user = localStorage.getItem("UserRole")
        if (user != "DEPARTMENT_HEAD") {
            service.GetAllDepartmentUnitDropDown(id)
                .then((response) => {
                    console.log("Department Unit")
                    console.log(response);
                    if (response.data.Status === "200") {
                        setDepartmentUnitArr(response.data.Data)
                    } else {
                        setDepartmentUnitArr([])
                    }
                })
        }
        else {
            service.GetAllDepartmentUnitDropDownOnProject(id, assign)
                .then((response) => {
                    console.log("Department Unit")
                    console.log(response);
                    if (response.data.Status === "200") {
                        setDepartmentUnitArr(response.data.Data)
                    } else {
                        setDepartmentUnitArr([])
                    }
                })
        }
    }

    //---------------------EmployeeList Dropdown-------------------//

    const ViewProjectManagerList = () => {
        service.GetAllEmployeeNameDropDown()
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data === null || response.data.Data === null) {
                    setProjectManagerArr([])
                }
                else {
                    setProjectManagerArr(response.data.Data);
                }
            })
    }

    //.........................Project Datatable.............................//

    const openmodal = (id: any) => {
        setId(id);
        setModalopen(true);
        service.GetProjectById(id)
            .then((response) => {
                if (response.status === 200) {
                    setProjectStatus(response.data.data.projectStatus.status);
                    swal({
                        title: 'Confirm!',
                        text: 'Is this the project you would like to Close/Hold/UnHold',
                        icon: 'info',
                        closeOnClickOutside: false,
                        buttons: {
                            yes: {
                                text: 'Yes',
                                value: 'yes',
                                className: 'btn-yes',
                            },
                            no: {
                                text: 'No',
                                value: 'no',
                                className: 'btn-no'
                            },
                        }
                    }).then((value: string) => {
                        if (value  === 'yes') {
                        } else if(value === 'no') {
                            setModalopen(false);
                        }
                    });
                
                    console.log(response.data);

                    if (response.data.data.projectName === null || response.data.data.projectName === "") {
                        setPname("")
                    }
                    else {
                        setPname(response.data.data.projectName)
                    }
                    if (response.data.data.client.clientName === null || response.data.data.client.clientName === "") {
                        setCname("")
                    }
                    else {
                        setCname(response.data.data.client.clientName)
                    }
                    if (response.data.data.fromDate === null || response.data.data.fromDate === "") {
                        setFDate("")
                    }
                    else {
                        setFDate(response.data.data.fromDate)
                    }
                    if (response.data.data.toDate === null || response.data.data.toDate === "") {
                        setTDate("")
                    }
                    else {
                        setTDate(response.data.data.toDate)
                    }
                    if (response.data.data.businessUnitId === null || response.data.data.businessUnitId === "") {
                        setUpdateBussinessUnit("")
                    }
                    else {
                        setUpdateBussinessUnit(response.data.data.businessUnitId)
                        ViewAllDepartmentunit(response.data.data.businessUnitId)
                    }
                    if (response.data.data.masterDepartmentId === null || response.data.data.masterDepartmentId === "") {
                        setUpdateDepartmentUnit("")
                    }
                    else {
                        setUpdateDepartmentUnit(response.data.data.masterDepartmentId)
                    }
                    if (response.data.data.projectManager === null || response.data.data.projectManager === "") {
                        setUpdateProjectManager("")
                    }
                    else {
                        setUpdateProjectManager(response.data.data.projectManager)
                    }
                    if (response.data.data.project_Description === null || response.data.data.project_Description === "") {
                        setDeasc("")
                    }
                    else {
                        setDeasc(response.data.data.project_Description)
                    }
                    if (response.data.data.assignedResources === null || response.data.data.assignedResources === "") {
                        setAssignedResources([])
                    }
                    else {
                        setAssignedResources(response.data.data.assignedResources)
                    }
                }
            })
    }

    const closemodal = () => {
        setHideButtons(false);
        setModalopen(false);
        setshowfield(false);
        setRemarks("");
        setCname("");
        setPname("");
        setFDate("");
        setTDate("");
        setDeasc("");
        setUpdateBussinessUnit("");
        setUpdateDepartmentUnit("");
        setUpdateProjectManager("");
        setAssignedResources([]);
    }

    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Project Closure
                                    </h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status </label>
                                        <Select
                                            options={options9}
                                            value={options9.find((option: any) => option.value === projectStatusId) || null}
                                            onChange={hanldeStatusTypes}
                                            onInputChange={handleInputChange9}
                                            onMenuOpen={handleMenuOpen9}
                                            onMenuClose={handleMenuClose9}
                                            onFocus={handleFocus9}
                                            onBlur={handleBlur9}
                                            menuIsOpen={menuIsOpen9}
                                            isSearchable
                                            // disabled={isEdit === true ? false : true}
                                            placeholder={<Placeholder9 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator9,
                                            }}
                                            className="custom-select0"
                                        />

                                    </div>

                                </div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                        LoadProject();
                                    }} className="btn btn-orange btn-block w-100"> SEARCH </a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*.....................View Project .................. */}
                <Modal
                    // id="logouts-modal"
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen}
                >
                    <div className="modal-header" >
                        <h5 className="modal-title">View Project</h5>
                        <button  type="button" style={{ zIndex: 30000 }}  className="close modal-overlay" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Name <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={pname} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setPname(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Client Name <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={cname} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>From Date<span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" disabled={isEdit === true ? false : true} value={fDate} onIonChange={(e: any) => setFDate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>To Date <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" disabled={isEdit === true ? false : true} value={tDate} onIonChange={(e: any) => setTDate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">

                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Bussiness Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionss}
                                                    value={optionss.find((option: any) => option.value === updateBussinessUnit) || null}
                                                    onChange={handleBusinessChange}
                                                    onInputChange={handleInputChange1}
                                                    onMenuOpen={handleMenuOpen1}
                                                    onMenuClose={handleMenuClose1}
                                                    onFocus={handleFocus1}
                                                    onBlur={handleBlur1}
                                                    menuIsOpen={menuIsOpen1}
                                                    isSearchable
                                                    placeholder={<Placeholders />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicators,
                                                    }}
                                                    className="custom-select3"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Department Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionsss}
                                                    value={optionsss.find((option: any) => option.value === updateDepartmentUnit) || null}
                                                    onChange={handleDepartmentChange}
                                                    onInputChange={handleInputChange2}
                                                    onMenuOpen={handleMenuOpen2}
                                                    onMenuClose={handleMenuClose2}
                                                    onFocus={handleFocus2}
                                                    onBlur={handleBlur2}
                                                    menuIsOpen={menuIsOpen2}
                                                    isSearchable
                                                    placeholder={<Placeholder2 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator2,
                                                    }}
                                                    className="custom-select4"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Managers<span className="text-danger">*</span></label>

                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === updateProjectManager) || null}
                                                    onChange={handleprojectUnitChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Description <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput disabled={isEdit === true ? false : true} value={desc} onIonChange={(e: any) => setDeasc(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="submit-section">
                                    {buttons}
                                </div>
                                <div className="form-group" style={{ marginTop: "2%" }}>
                                    <label style={{ fontWeight: "bold" }}>Assigned Resources </label>
                                    <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                        {assignedResources.length > 0 && assignedResources.map((itm: any) => (
                                            <li style={{ paddingLeft: "4px" }}>{itm}</li>
                                        ))}
                                    </div>
                                </div>
                                {showfield && (
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Closure/Hold Date</label>
                                                <div>
                                                    <IonInput
                                                        readonly
                                                        className="form-control datetimepicker"
                                                        value={getCurrentDate()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Closure/Hold Remark</label>
                                                <div>
                                                    <IonInput value={remarks} onIonChange={(e: any) => setRemarks(e.target.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="submit-section">
                                            <button type="button" className="btn-primary submit-btn" onClick={AssignGeneralActivity}>Submit</button>
                                            <button onClick={() => {
                                                resetRemarks();
                                                setshowfield(false); 
                                                closemodal();
                                            }} type="button" className="btn-primary submit-btn">Cancel</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default ProjectClosure
